import { render, staticRenderFns } from "./mobile_head.vue?vue&type=template&id=b8507698&scoped=true"
import script from "./mobile_head.vue?vue&type=script&lang=js"
export * from "./mobile_head.vue?vue&type=script&lang=js"
import style0 from "./mobile_head.vue?vue&type=style&index=0&id=b8507698&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8507698",
  null
  
)

export default component.exports